import React from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import i18n from 'i18n-js';
import {fontFamily} from '../../helpers/fontFamily';

const UnsavedChangesBar = ({
  visible,
  onSave,
  onDiscard,
  saving = false,
  message = i18n.t('unsavedChanges.bannerMessage'),
  saveText = i18n.t('unsavedChanges.save'),
  discardText = i18n.t('unsavedChanges.discard')
}) => {
  if (!visible) return null;

  return (
    <View style={styles.bar} testID="unsavedChangesBar">
      <Text style={styles.message}>{message}</Text>
      <View style={styles.actions}>
        <TouchableOpacity
          testID="unsavedChangesDiscard"
          onPress={onDiscard}
          disabled={saving}
          style={styles.discardButton}>
          <Text style={styles.discardText}>{discardText}</Text>
        </TouchableOpacity>
        <TouchableOpacity
          testID="unsavedChangesSave"
          onPress={onSave}
          disabled={saving}
          style={[styles.saveButton, saving && {opacity: 0.6}]}>
          <Text style={styles.saveText}>{saving ? i18n.t('unsavedChanges.saving') : saveText}</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  bar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 12,
    paddingVertical: 10,
    paddingHorizontal: 20,
    backgroundColor: '#1e3048',
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.15)',
    zIndex: 20
  },
  message: {
    fontFamily: fontFamily.font500,
    fontSize: 14,
    color: '#F8E96A'
  },
  actions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10
  },
  discardButton: {
    borderRadius: 6,
    height: 36,
    minWidth: 110,
    paddingHorizontal: 20,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor: '#3D5A73'
  },
  discardText: {
    fontFamily: fontFamily.font600,
    color: '#FFFFFF',
    fontSize: 14
  },
  saveButton: {
    borderRadius: 6,
    height: 36,
    minWidth: 110,
    paddingHorizontal: 20,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1CBB77'
  },
  saveText: {
    fontFamily: fontFamily.font600,
    color: '#FFFFFF',
    fontSize: 14
  }
});

export default UnsavedChangesBar;
